<template>

  <div class="img_title" v-if="this.info && this.info.title_type === '2'" @click.prevent="click_more">
      <img :src="imgTitle"/>
  </div>
  <div class="title" v-else-if="this.info.title_type === '1'">
    <div class="main">
      <img v-if="titleIcon" :src="titleIcon" class="main_icon" />
      <div :style="textMainColorStyle" class="main_text">{{this.info.title}}</div>
    </div>
    <div class="more" v-if="this.info.more_url" @click.prevent="click_more">
      <div :style="textSubColorStyle" class="more_text">更多</div>
      <img  class="more_icon" :src="moreIcon" alt="">
    </div>
    <div class="more more-img" v-else-if="!this.info.more_url && this.config.more_info_icon" @click.prevent="click_more_pop">
      <img  class="more_icon" :src="this.config.more_info_icon" alt="">
    </div>
  </div>
</template>
<script>
import { openLink } from "../../tools/mgtv/link";
import click_handler from "../../tools/mgtv/click";
import { urlToWebp } from '../../tools/tpl';

export default {
  name: "Title",
  props: {
    parent_name: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default: () => {return {}}
    },
    info: {
      type: Object,
      default: () => {
        return {
          title: "我是标题 我是标题",
          icon: "https://via.placeholder.com/64x32?text=VIP",
          more_url: "https://www.mgtv.com",
          img_title:"" //居中的图片标题
        };
      }
    }
  },
  data: function() {
    return {};
  },
  methods: {
    click_more_pop() {
      click_handler(`${this.parent_name}-弹窗`,() => {
        window.$act_img_dialog.show({img: this.config.more_info_img})
      })
    },
    click_more() {
      click_handler(`${this.parent_name}-更多`, () => {
        setTimeout(() => {
          openLink(this.info.more_url);
        }, 200);
      });
    }
  },
  mounted() {

  },

  computed: {
    textMainColorStyle:function(){
      return window.$bus.textMainColorStyle
    },
    textSubColorStyle:function(){
      return window.$bus.textSubColorStyle
    },
    moreIcon:function(){
      return window.$bus.tpl.tpl_page.customColorMoreIcon || 'https://vipcdn.mgtv.com/upload3/202001/arrow_icon.svg'
    },
    imgTitle(){
      return urlToWebp(this.info.img_title)
    },
    titleIcon(){
      return urlToWebp(this.info.icon)
    }
  }
};
</script>


<style lang="stylus" scoped>
  @import "../../share/mixins.styl"
 .img_title
   width 7.5rem
   position relative
   display flex
   justify-content center
   padding .2rem 0 .12rem
   margin-bottom .16rem
   img
     width 6rem
 .title
    width 7.5rem
    position relative
    display flex
    padding .2rem .3rem .12rem
    justify-content space-between
    align-items center
    margin-bottom .16rem
    .main
      display flex
      align-items center
      .main_icon
        height .32rem
        margin-right  .14rem
        @media screen and (min-width: 700px)
          height 20PX
      .main_text
        font-size .34rem
        font-weight  bold
        white-space nowrap
        display block
        ellipsis()
        width 4rem
        @media screen and (min-width: 700px)
          font-size 20PX

    .more
      display flex
      align-items center
      position relative
      height 100%
      &.more-img
        img
          width: 2.16rem
          height: 0.64rem
      .more_text
        font-size .22rem
        color #969696
        display block
        white-space nowrap
      .more_icon
        height .26rem
        margin-left  .05rem
        margin-top -.03rem


</style>
